var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 10 10"}},[_c('path',{attrs:{"d":"M 0.334 4.334 H 9.6673 V 5.6668 H 0.334 V 4.3335 Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }